import React from 'react';
import '../styles/theme.css';
import '../styles/Operations.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import OperationsContinueBand from '../components/OperationsContinueBand';
import OperationsAccountServicingBlock from '../components/OperationsAccountServicingBlock';
import OperationsTransferOversightBlock from '../components/OperationsTransferOversightBlock';
/* IMPORTS */

function OperationsPage() {
  return (
    <div className="op-root">
      <div id="operationsheader" className="op-slot-operationsheader">
        <Navbar activePage={"Operations"} />
      </div>
      <div id="operationsaccountservicingblock" className="op-slot-operationsaccountservicingblock">
        <OperationsAccountServicingBlock />
      </div>
      <div id="operationstransferoversightblock" className="op-slot-operationstransferoversightblock">
        <OperationsTransferOversightBlock />
      </div>
      <div id="operationscontinueband" className="op-slot-operationscontinueband">
        <OperationsContinueBand />
      </div>
      <div id="operationsfooter" className="op-slot-operationsfooter">
        <Footer />
      </div>
    </div>
  );
}

export default OperationsPage;